import Main from "../../components/main/main";
import styles from  './main-page.module.css';

function MainPage() {	
  return (
    <div className={styles.wrapper}>				
			<Main/>							     
    </div>
  );
}

export default MainPage;
